import EUBlockedContent from 'shared/EUBlockedContent/EUBlockedContent'
import { SectionHeading } from '../../../../../components/headings'

const EUBlockedOnboarding = () => (
  <div>
    <SectionHeading className="h-article h3 mvxl text-center text-bold">
      Create Your Babylist
    </SectionHeading>
    <EUBlockedContent />
  </div>
)

export default EUBlockedOnboarding
